import { render } from "./SearchByName.vue?vue&type=template&id=3875288f"
import script from "./SearchByName.vue?vue&type=script&lang=js"
export * from "./SearchByName.vue?vue&type=script&lang=js"

import "./SearchByName.vue?vue&type=style&index=0&id=3875288f&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__